import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { objections } from '../../data/content';
export function Objections() {
  return <section className="bg-cream py-10 sm:py-14" data-id="element-108" data-mp="218b5rqlcyp51">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-109" data-mp="217i7le0gt7yi">
        <SectionTag data-id="element-110" data-mp="267xje153m7ed">Objeciones comunes</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-navy sm:text-4xl" data-id="element-111" data-mp="268paozrnxiyu">
          Lo que algunos piensan (y por qué se equivocan)
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-2xl space-y-4 px-4 sm:px-6" data-id="element-112" data-mp="2f69ikrk16dif">
        {objections.map((objection, i) => <m.div key={objection.q} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.08
      }} className="rounded-2xl border border-navy/10 bg-white p-6" data-id="element-113" data-mp="2k159fodj6uty" data-mpi={i}>
            <p className="font-heading text-base font-semibold italic text-navy" data-id="element-114" data-mp="3tx6nb923n82c">{objection.q}</p>
            <p className="mt-2 text-sm leading-relaxed text-ink" data-id="element-115" data-mp="3oymyn0w4fi6a">{objection.a}</p>
          </m.div>)}
      </div>
    </section>;
}